module.exports = __webpack_public_path__ + "static/img/10.9f98c77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/10.png
// module id = B6mP
// module chunks = 0